import axios from '@ts/utils/axios';

export function fetch(params = {}, rest = {}) {
    return axios.get('/order', { params, ...rest }).then(({ data }) => data);
}

export function fetchByAccessKey(accessKey, rest = {}) {
    return fetch({ accesskey: accessKey }, rest);
}
